import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { features } from "../mock";

const Features = () => {
  const [active, setActive] = useState(features[0].id);
  const current = features.find((f) => f.id === active);

  return (
    <section id="features" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.18em] text-teal-700 font-medium">
            One connected app. Built for flourishing.
          </div>
          <h2 className="mt-4 text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-black leading-[1.05]">
            Replace the patchwork with{" "}
            <em className="text-teal-700 font-serif font-normal">
              one connected system.
            </em>
          </h2>
          <p className="mt-5 text-lg text-black/60">
            Where every interaction deepens the relationship instead of
            interrupting it.
          </p>
        </div>

        {/* Tabs */}
        <div className="mt-12 flex flex-wrap gap-2 md:gap-3">
          {features.map((f) => (
            <button
              key={f.id}
              onClick={() => setActive(f.id)}
              className={`px-4 md:px-5 h-11 rounded-full text-sm font-medium border transition-all duration-200 ${
                active === f.id
                  ? "bg-black text-white border-black"
                  : "bg-white text-black/70 border-black/15 hover:border-black/40 hover:text-black"
              }`}
            >
              <span className="text-teal-500 mr-2 font-mono text-xs">
                {f.number}
              </span>
              {f.tag}
            </button>
          ))}
        </div>

        {/* Feature display */}
        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          <div className="relative aspect-[4/3] rounded-2xl overflow-hidden bg-black">
            <img
              key={current.image}
              src={current.image}
              alt={current.title}
              loading="lazy"
              className="w-full h-full object-cover animate-[fadeIn_0.4s_ease]"
            />
            <div className="absolute top-5 left-5 bg-white/95 backdrop-blur rounded-full px-4 py-1.5 text-xs font-semibold text-black tracking-wide">
              <span className="text-teal-600 mr-2">{current.number}</span>
              {current.tag}
            </div>
          </div>
          <div>
            <h3 className="text-3xl md:text-4xl font-semibold tracking-tight text-black leading-tight">
              {current.title}
            </h3>
            <p className="mt-5 text-black/65 text-lg leading-relaxed">
              {current.body}
            </p>
            <button className="mt-8 inline-flex items-center gap-2 text-black font-semibold border-b border-black/25 pb-1 hover:text-teal-700 hover:border-teal-700 transition-colors">
              {current.cta}
              <ArrowRight className="w-4 h-4" />
            </button>

            <div className="mt-10 space-y-3">
              {features
                .filter((f) => f.id !== active)
                .map((f) => (
                  <button
                    key={f.id}
                    onClick={() => setActive(f.id)}
                    className="group w-full text-left flex items-center justify-between py-3 border-t border-black/10 hover:border-teal-600/40 transition-colors"
                  >
                    <div className="flex items-center gap-4">
                      <span className="text-teal-600 font-mono text-xs">
                        {f.number}
                      </span>
                      <span className="text-black font-medium">{f.tag}</span>
                      <span className="hidden md:inline text-black/50 text-sm">
                        {f.title}
                      </span>
                    </div>
                    <ArrowRight className="w-4 h-4 text-black/40 group-hover:text-teal-600 group-hover:translate-x-1 transition-all" />
                  </button>
                ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: scale(1.02); } to { opacity: 1; transform: scale(1); } }
      `}</style>
    </section>
  );
};

export default Features;
